import {Component, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {UserService} from '../../../services/user.service';
import {FiltroConsultaMicroempresarios} from '../../Model/filtroConsultaMicroempresarios';
import {ConsultaMicroempresariosService} from '../../Service/consultaMicroempresarios.service';
import {Router} from '@angular/router';
import {AlertService} from "../../../services/alert.service";
import { SweetAlertService } from 'src/app/services/sweet-alert.service';

declare var $: any;
@Component({
    selector: 'app-consultar-historico-solicitudes',
    templateUrl: './consultar-historico-solicitudes.component.html',
    styleUrls: ['./consultar-historico-solicitudes.component.scss'],
    standalone: false
})
export class ConsultarHistoricoSolicitudesComponent implements OnInit {
  consultarHistoricoForm: UntypedFormGroup;
  consulta = false;
  estados: any[] = [];
  idCliente: any;
  totalPaginas = 1;
  paginaActual = 0;
  fechaActual: string = new Date().toLocaleDateString('en-CA');
  filtrosConsulta: FiltroConsultaMicroempresarios;
  historico: any[] = [];
  constructor(
    private user: UserService,
    private alertService: AlertService,
    private formBuilder: UntypedFormBuilder,
    private consultaMicroService: ConsultaMicroempresariosService,
    public router: Router,
    private _sweetAlert:SweetAlertService
  ) {
    this.consultarHistoricoForm = this.formBuilder.group({
      fechaInicial: [null],
      fechaFinal: [null],
      estado: [null],
      pagina: 1
    });
  }

  ngOnInit(): void {
    this.idCliente = this.user.getUser().idCliente;
    if(sessionStorage.getItem('filterConsultaHistorico')){
      this.consultarHistoricoForm.setValue(JSON.parse(sessionStorage.getItem('filterConsultaHistorico')));
      sessionStorage.removeItem('filterConsultaHistorico');
      this.consultarHistorico();
    }

    this.consultaMicroService.getEstadosIntermediario().subscribe(
      (response) => {
        this.estados = response;
      },
      (error) => {
        this._sweetAlert.errorModal("Error!",true,
        'No fue posible cargar los datos');
      },
      () => {
        setTimeout(() => {
          $('.selectpicker').selectpicker('refresh');
        });
      }
    );
  }

  crearObjetoFiltrosHistorico(): FiltroConsultaMicroempresarios {
    const filtros: FiltroConsultaMicroempresarios = {
      fechaFinal: this.obtenerValorCampo('fechaFinal'),
      fechaInicial: this.obtenerValorCampo('fechaInicial'),
      estado: this.obtenerValorCampo('estado'),
      idCliente: Number(this.idCliente),
      numPagina: this.obtenerValorCampo('pagina'),
      excel: null,
    };
    return filtros;
  }

  consultarHistorico() {
    this.filtrosConsulta = this.crearObjetoFiltrosHistorico();
    this.consultaMicroService
      .consultarHistoricoFiltro(this.filtrosConsulta)
      .subscribe (
        (response: any) => {
          this.totalPaginas = response.paginasTotales;
          this.historico = response.data;
          this.paginaActual = response.paginaActual;
          if (response.data.length > 0){
            this.consulta = true;
          }else{
            this.consulta = false;
            this.mensaje();
          }
        },
        (err) => {
          console.error(err);
        }
      );
  }

  isValidFieldConsultaMicroForm(field: string) {
    return (
      (this.consultarHistoricoForm.get(field)?.dirty ||
        this.consultarHistoricoForm.get(field)?.touched) &&
      this.consultarHistoricoForm.get(field)?.invalid
    );
  }

  campoContieneValor(nombreCampo: string): boolean {
    if (this.consultarHistoricoForm.get(nombreCampo).value) {
      return true;
    } else {
      return false;
    }
  }

  obtenerValorCampo(nombreCampo: string) {
    return this.consultarHistoricoForm.get(nombreCampo)?.value;
  }

  validarFechas() {
    let fechaInicial = new Date();
    let fechaFinal = new Date();
    if (this.campoContieneValor('fechaInicial')) {
      fechaInicial = new Date(this.obtenerValorCampo('fechaInicial'));
    }
    if (this.campoContieneValor('fechaFinal')) {
      fechaFinal = new Date(this.obtenerValorCampo('fechaFinal'));
    }
    if (fechaInicial.getTime() > fechaFinal.getTime()) {
      this.consultarHistoricoForm.controls.fechaInicial.setErrors({
        incorrect: true,
      });
    } else {
      this.consultarHistoricoForm.controls.fechaInicial.setErrors(null);
      this.consultarHistoricoForm.controls.fechaFinal.setErrors(null);
    }
  }

  cualquierCampoIngresado(): boolean {
    return (
      this.campoContieneValor('estado') ||
      this.campoContieneValor('fechaInicial') ||
      this.campoContieneValor('fechaFinal')
    );
  }

  limpiarFormulario() {
    this.consultarHistoricoForm.reset();
    this.consultarHistoricoForm.controls.pagina.patchValue(1);
    $('.selectpicker').selectpicker('refresh');
    this.consulta = false;
  }

  verDetalles(numeroSolicitud: any){
    sessionStorage.setItem('filterConsultaHistorico', JSON.stringify(this.consultarHistoricoForm.value));
    this.router.navigate([
      '/solicitud/intermediario/' + numeroSolicitud,
    ]);
  }

  // pagination
  resetPage() {
    this.consultarHistoricoForm.controls.pagina.patchValue(1);
  }

  selectPage(pageNumber: number) {
    this.consultarHistoricoForm.controls.pagina.patchValue(pageNumber);
    this.consultarHistorico();
  }

  mensaje(){
    $('#mensajeModal').modal('show');
  }

  generarReporte(isExcel: boolean) {
    this.filtrosConsulta.excel = isExcel;
    this.consultaMicroService
      .generarReporteCliente(this.filtrosConsulta)
      .subscribe(
        (response: any) => {
          if (response.exitoso === true) {
            const a = document.getElementById('downloadFile');
            a.setAttribute(
              'href',
              `data:${response.mimeType};base64,${response.data}`
            );
            a.setAttribute('download', unescape(response.fileName));
            a.click();
          }
        },
        (err) => {
          console.error(err);
        }
      );
  }
  separarString(cadena:string){
    const pattern = /([A-Z]?[^A-Z]*)/g
    let salida = cadena.replace(pattern, ' $1').replace(/^./, (str)=> {
      return str.toUpperCase();
    })
    return salida;
  }
}
